<angie-auth-wrapper [layoutConfig]="layoutConfig" [form]="authForm" title="{{ 'lup.login.login_heading' | translate }}">
	<a *ngIf="!data.hide_password_fields && !data.readonly_login_field"
		 class="forgot-password"
		 forgotPassword
		 [routerLink]="['../password/new']">
		{{ 'mails.forgot_your_password' | translate }}
	</a>

	<a *ngIf="!data.hide_password_fields && data.readonly_login_field"
		 class="forgot-password disabled-link"
		 forgotPassword
		 (click)="showPasswordChangeDisabled()">
		{{ 'mails.forgot_your_password' | translate }}
	</a>
	<button [disabled]="inProgress$ | async" [attr.qa-id]="'sign_in_btn'" type="submit" class="btn btn--theme btn--block" primaryAction (click)="signIn()">
		{{ 'lup.login.login_label' | translate }}
	</button>
	<span signUp
		>{{ 'new_store.no_account_yet' | translate }}
		<a [attr.qa-id]="'sign_up_link'" [href]="['users/sign_up']">
			{{ 'lup.login.register_link' | translate }}</a
		></span
	>
	<span signUpBottom
		>{{ 'new_store.no_account_yet' | translate }}
		<a [attr.qa-id]="'sign_up_link'" [routerLink]="['../sign_up']">
			{{ 'lup.login.register_link' | translate }}</a
		></span
	>
	<div class="socials-actions" customLogin>
		<span *ngIf="data.oauth || data.sqsso.link || data.saml.link || data.oidc.link" class="mb-12">{{ 'lup.login.login_with_label' | translate }}</span>
		<div class="o-flex o-flex--vcenter o-flex--flex-center social-spacing">
			<button *ngIf="data.oauth" [attr.qa-id]="'google_btn'" class="btn btn--social" (click)="oauth('google_oauth2')">
				<img class="btn__ico" [src]="cdnPath + '/assets/images/sign-in/google-sign-in.svg'" [alt]="'Google'" />
				Google
			</button>
			<angie-image-with-link
				class="saml"
				*ngIf="data.saml.link"
				[imgSrc]="data.saml.image_link"
				[imgAlt]="data.saml.image_alt"
				[link]="data.saml.link"></angie-image-with-link>
			<angie-image-with-link
				*ngIf="data.sqsso.link"
				[imgSrc]="data.sqsso.image_link"
				[imgAlt]="data.sqsso.image_alt"
				[link]="data.sqsso.link"></angie-image-with-link>
			<a *ngIf="data.oidc.link" [href]="data.oidc.link">
				<img
					[src]="data.oidc.image_link ? data.oidc.image_link : (cdnPath + '/assets/images/sign-in/openid-connect-sign-in.png')"
					[alt]="data.oidc.image_alt"
					[width]="32"
					[height]="32"
					style="padding-right: 10px;" />OpenID Connect</a>
		</div>
	</div>
</angie-auth-wrapper>
